import { fetch } from '../fetchWrapper/fetch';
import { Status } from '../constants';

export const postPublishRequest = async <TResponse>(
  url: string,
  payload: unknown,
  defaultErrorMessage: string,
): Promise<TResponse> => {
  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'content-type': 'application/json',
    },
  });

  const json = await res.json();

  if (res.status === Status.BAD_REQUEST) {
    throw new Error(json.message);
  }

  if (!res.ok) {
    let msg = defaultErrorMessage;
    if (Array.isArray(json?.errors) && typeof json.errors.at(0)?.message === 'string') {
      msg = json.errors.at(0)?.message;
    }

    throw new Error(msg);
  }
  return json;
};
